import { CrudModel } from './_crud';

export class AppointmentStatusModel extends CrudModel {
	constructor() {
		super('admin/appointmentstatus');
	}
}

export default new AppointmentStatusModel();
